import { acceptHMRUpdate, defineStore } from 'pinia'

export const useCarClarity = defineStore('carClarityModal', {
	namespaced: true,
	state: () => ({
		showRedirection: false,
		isPriority: false,
		isSubmitting: false,
		buttonTimer: null,
		redirectionTimer: null,

		loan: {
			loanAmount: null,
			loanTerm: null,
			ballonPct: null,
		},
	}),

	getters: {},

	actions: {
		goToRedirection() {
			this.isSubmitting = true
			this.buttonTimer = setTimeout(() => {
				this.showRedirection = true
			}, 1500)
		},

		redirectToCarClarity() {
			const runtimeConfig = useRuntimeConfig()
			navigateTo(
				{
					path: runtimeConfig.public.CAR_CLARITY_APP_URL,
					query: {
						loanAmount: this.loan.loanAmount,
						loanTermYears: this.loan.loanTerm,
						balloonPct: this.loan.ballonPct,
						partner_id: runtimeConfig.public.CAR_CLARITY_PARTNER_ID,
					},
				},
				{
					external: true,
					open: {
						target: '_blank',
					},
				}
			)
		},

		clearAndResetTimer() {
			if (this.isSubmitting === true) {
				clearTimeout(this.buttonTimer)
				clearTimeout(this.redirectionTimer)
				this.isSubmitting = false
			} else {
				this.showRedirection = false
			}
		},

		resetAll() {
			this.$reset()
		},
	},
})

if (import.meta.hot) {
	import.meta.hot.accept(acceptHMRUpdate(useCarClarity, import.meta.hot))
}
